export default __webpack_public_path__ + "static/media/no-orders.06ea8ec7.png";